// Frontend-only mock data (no backend yet)
// All interactive actions currently persist to localStorage.

export const mock = {
  company: {
    name: "Shiveda IT Services",
    tagline: "Development-first digital Services for teams that ship.",
    shortBlurb:
      "We design and engineer web apps, mobile products, ERP systems, and SaaS platforms built for performance, maintainability, and scale.",
    contact: {
      email: "support@shivedait.com",
      whatsapp: "+91 89538 91461",
      location: "India (Remote-first)",
    },
  },
  nav: [
    { label: "Home", to: "/" },
    { label: "About", to: "/about" },
    { label: "Services", to: "/services" },
    { label: "Projects", to: "/projects" },
    { label: "Workshops", to: "/workshops" },
    { label: "Company", to: "/company" },
    { label: "Pricing", to: "/contact" },
  ],
  services: [
    {
      id: "web-dev",
      title: "Web Development",
      short:
        "Performance driven web applications. Architected for clarity, engineered for speed, and built to scale effortlessly.",
      problems: [
        "Slow sites and poor Core Web Vitals",
        "Unmaintainable codebases",
        "Complex product workflows",
      ],
      process: [
        "Discovery & scope",
        "UI/UX + IA",
        "Build (React / API)",
        "QA + Launch + Monitoring",
      ],
      deliverables: [
        "Component library + UI kit",
        "Responsive pages",
        "API integration",
        "Deployment + observability baseline",
      ],
      tools: ["React", "FastAPI", "Node", "MongoDB", "PostgreSQL", "AWS"],
    },
    {
      id: "mobile",
      title: "Mobile App Development",
      short:
        "Scale your reach with battle tested iOS and Android apps engineered for reliability and an intuitive, frictionless UX.",
      problems: [
        "Inconsistent UI across devices",
        "Crashy builds and release anxiety",
        "Slow iterations",
      ],
      process: ["Product spec", "Design system", "Build", "Store release"],
      deliverables: [
        "App UI + flows",
        "Auth + push notifications",
        "Analytics events",
        "App Store / Play Store release",
      ],
      tools: ["React Native", "Flutter", "Firebase", "FastAPI"],
    },
    {
      id: "erp",
      title: "ERP & Enterprise Services",
      short:
        "Synchronized ops, finance, and inventory. Custom built dashboards and automations designed to simplify scaling.",
      problems: [
        "Disconnected spreadsheets",
        "Manual approvals",
        "Limited reporting",
      ],
      process: ["Process mapping", "Data model", "Build", "Rollout & training"],
      deliverables: [
        "Role-based access",
        "Approvals + audit logs",
        "Dashboards",
        "Data migration support",
      ],
      tools: ["FastAPI", "PostgreSQL", "MongoDB", "Redis"],
    },
    {
      id: "saas",
      title: "SaaS Product Development",
      short:
        "Turn your MVP into a v1 powerhouse with our evolutionary product engineering focused on speed and clarity to drive user retention.",
      problems: ["Scope creep", "Unclear MVP", "Scaling pains"],
      process: ["MVP blueprint", "Build", "Instrument", "Iterate"],
      deliverables: [
        "MVP feature set",
        "Admin panel",
        "Analytics + events",
        "Scalable architecture",
      ],
      tools: ["React", "FastAPI", "Stripe-ready", "CI/CD"],
    },
    {
      id: "uiux",
      title: "UI/UX Design",
      short:
        "Clarity by design. We pair a modern, premium aesthetic with conversion driven UX to ensure your product is as intuitive as it is beautiful.",
      problems: [
        "Low conversion landing pages",
        "Inconsistent UI",
        "Poor onboarding",
      ],
      process: ["Research", "Wireframes", "UI kit", "Handoff"],
      deliverables: [
        "Figma system",
        "Responsive designs",
        "Interaction specs",
        "Design QA support",
      ],
      tools: ["Figma", "Design systems", "Prototyping"],
    },
    {
      id: "cloud",
      title: "Cloud & DevOps",
      short:
        "Deployments, environments, and reliability for teams that need confidence.",
      problems: ["Fragile deploys", "No staging", "Downtime"],
      process: ["Infra plan", "Pipelines", "IaC", "Monitoring"],
      deliverables: [
        "CI/CD pipeline",
        "Staging + production",
        "Logging + metrics",
        "Infra documentation",
      ],
      tools: ["Docker", "AWS", "GCP", "Nginx"],
    },
    {
      id: "support",
      title: "Maintenance & Support",
      short:
        "Long-term partnership: monitoring, improvements, and quick fixes.",
      problems: ["Random breakages", "Slow bug turnaround", "Unplanned costs"],
      process: ["Audit", "Backlog", "Sprints", "Reporting"],
      deliverables: ["SLA options", "Monthly reports", "Security patches"],
      tools: ["Sentry", "Uptime checks", "CI"],
    },
    {
      id: "mvp-rapid",
      title: "MVP & Rapid Prototyping",
      short:
        "Quickly validate your product ideas and get to market faster with our MVP development and rapid prototyping services.",
      problems: ["Uncertain market fit", "High development costs", "Slow validation cycles"],
      process: ["Idea validation", "Wireframes & prototypes", "MVP development", "User feedback & iteration"],
      deliverables: [
        "Clickable prototypes",
        "Core feature MVP",
        "User analytics integration",
        "Feedback collection system"
      ],
      tools: ["Figma", "React", "FastAPI", "Firebase", "Analytics"],
    },
    {
      id: "ai-ml",
      title: "AI & Machine Learning Strategy",
      short:
        "Unlock the power of AI for your business. We help you define, plan, and implement a winning AI/ML strategy tailored to your goals.",
      problems: ["Unclear AI potential", "Data readiness gaps", "Implementation complexity"],
      process: ["AI readiness assessment", "Data strategy & planning", "Model development", "Implementation & monitoring"],
      deliverables: [
        "AI strategy roadmap",
        "Data pipeline setup",
        "Custom ML models",
        "AI governance framework"
      ],
      tools: ["Python", "TensorFlow", "AWS SageMaker", "MLOps", "Data pipelines"],
    },
    {
      id: "generative-ai",
      title: "Generative AI Solutions",
      short:
        "Transform your business with cutting-edge generative AI. We design and deploy custom solutions using LLMs, image generation, and more.",
      problems: ["Manual content creation", "Inefficient workflows", "Limited personalization"],
      process: ["Use case identification", "Model selection & fine-tuning", "Integration development", "Optimization & scaling"],
      deliverables: [
        "Custom LLM applications",
        "Automated content generation",
        "AI-powered workflows",
        "Performance monitoring tools"
      ],
      tools: ["OpenAI", "Anthropic", "LangChain", "Vector databases", "API integration"],
    },
  ],
  techStack: [
    {
      group: "Frontend",
      items: ["React", "TypeScript", "Tailwind", "Shadcn UI", "Vite/Cra"],
    },
    {
      group: "Backend",
      items: ["FastAPI", "Node", "REST", "Webhooks", "Background jobs"],
    },
    {
      group: "Data",
      items: ["MongoDB", "PostgreSQL", "Redis", "Search", "ETL"],
    },
    {
      group: "Cloud",
      items: ["Docker", "CI/CD", "AWS", "GCP", "Observability"],
    },
  ],
  pricing: [
    {
      id: "starter",
      name: "Starter",
      price: "From $2,500",
      blurb: "Landing pages, small websites, and quick MVP validation.",
      includes: [
        "Discovery workshop",
        "Modern UI",
        "SEO structure",
        "Basic deployment",
      ],
      bestFor: "Founders validating an idea",
    },
    {
      id: "standard",
      name: "Standard",
      price: "From $7,500",
      blurb: "Production-ready product build with a scalable foundation.",
      includes: [
        "Design system",
        "Frontend + backend",
        "Analytics events",
        "QA + release plan",
      ],
      bestFor: "Startups shipping v1",
      highlight: true,
    },
    {
      id: "custom",
      name: "Custom",
      price: "Let’s talk",
      blurb: "ERP, complex SaaS, integrations, and long-term engineering.",
      includes: [
        "Architecture + roadmap",
        "Security + roles",
        "DevOps + environments",
        "Ongoing improvements",
      ],
      bestFor: "Teams needing long-term partnership",
    },
  ],
  faqs: [
    {
      q: "What kind of teams do you work with?",
      a: "Startups, SMEs, and enterprise teams especially those who need speed without sacrificing code quality.",
    },
    {
      q: "Do you provide UI/UX along with development?",
      a: "Yes. We can deliver Figma first design systems and implement them as reusable components.",
    },
    {
      q: "How do we start?",
      a: "Send your brief, we’ll schedule a discovery call, then share a scoped proposal with timelines.",
    },
  ],
};

export const storageKeys = {
  leads: "shiveda_leads_v1",
};

export function loadLeads() {
  try {
    const raw = localStorage.getItem(storageKeys.leads);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveLead(lead) {
  const leads = loadLeads();
  const next = [
    {
      id: crypto?.randomUUID?.() ?? String(Date.now()),
      createdAt: new Date().toISOString(),
      ...lead,
    },
    ...leads,
  ].slice(0, 50);
  localStorage.setItem(storageKeys.leads, JSON.stringify(next));
  return next;
}
